export default __webpack_public_path__ + "static/media/property_611.ad29649d.png";